import React from 'react'
import { string, bool } from 'prop-types'
import styled from '@emotion/styled'

const Checkmark = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
      fill="#31C8E0"
    />
    <path
      d="M4.68604 6.46895L6.55502 8.43838L9.80583 5.31641"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
)

const Image = styled.img`
  display: block;
  width: 100%;
`

const RoundBorder = styled.div`
  height: 72px;
  width: 72px;
  overflow: hidden;
  border: 1px solid #dddddd;
  border-radius: 50%;
  padding: 2px;
`

const ImageWrapper = styled.div`
  position: relative;
`

const BottomRight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`
const Wrapper = styled.div`
  display: inline-flex;
`

const TitleWrapper = styled.div`
  margin-left: 12px;
`

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
`

const Subtitle = styled.div`
  font-size: 20px;
  color: #dddddd;
`

const Avatar = ({
  url, verified, altText, title, subtitle,
}) => (
  <Wrapper>
    <ImageWrapper>
      <RoundBorder>
        <Image src={url} alt={altText} />
      </RoundBorder>
      {verified && (
        <BottomRight>
          <Checkmark />
        </BottomRight>
      )}
    </ImageWrapper>
    <TitleWrapper>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </TitleWrapper>
  </Wrapper>
)

Avatar.propTypes = {
  url: string.isRequired,
  verified: bool,
  altText: string,
  title: string,
  subtitle: string,
}

Avatar.defaultProps = {
  verified: false,
  altText: '',
  title: null,
  subtitle: null,
}

export default Avatar
